import React from 'react';
import {
  TableCell,
  TableRow,
  TableHeader as BaseTableHeader,
} from '../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';

export const TableHeader = () => (
  <BaseTableHeader>
    <TableRow noBorder px="24">
      <TableCell width="60%">
        <Text variant="tableHeader">Account Name</Text>
      </TableCell>
      <TableCell width="25%" justifyContent="flex-end">
        <Text variant="tableHeader">Status</Text>
      </TableCell>
      <TableCell width="15%" />
    </TableRow>
  </BaseTableHeader>
);
